import React from 'react';

type ErrorStatusIconProps = {
  width?: number;
  height?: number;
};

const ErrorStatusIcon = ({ width = 32, height = 32 }: ErrorStatusIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
    >
      <circle cx='16' cy='16' r='16' fill='#EF5251' />
      <path
        d='M19.3333 12.6665L12.6666 19.3332M12.6666 12.6665L19.3333 19.3332'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default ErrorStatusIcon;
